import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

export const PROJECT_KPI_SUMMARY_QUERY = gql`
  query ProjectKPISummary($projectId: String!, $dateRange: DateRangeInput2) {
    project(projectId: $projectId) {
      id
      teamMembersTimesheetCountSummary(dateRange: $dateRange) {
        waitingTimesheetCount
        approvedTimesheetCount
        totalTimesheetCount
      }
      billableNonBillableHoursSummary(dateRange: $dateRange) {
        billableHours
        totalHours
      }
      tasksCompletionCountSummary(dateRange: $dateRange) {
        closedOnOrBeforeTaskEndDateCount
        totalTaskCount
      }
      tasksCount
    }
  }
`;

const useProjectKPISummary = ({ projectId, dateRange }) => {
  const { data, loading } = useQuery(PROJECT_KPI_SUMMARY_QUERY, {
    variables: {
      projectId,
      dateRange: dateRange
        ? {
            startDate: dateRange.startDate.toISODate(),
            endDate: dateRange.endDate.toISODate()
          }
        : null
    },
    skip: !projectId,
    fetchPolicy: 'cache-and-network'
  });

  return {
    teamMembersTimesheetCountSummary:
      data?.project?.teamMembersTimesheetCountSummary,
    billableNonBillableHoursSummary:
      data?.project?.billableNonBillableHoursSummary,
    tasksCompletionCountSummary: data?.project?.tasksCompletionCountSummary,
    tasksCount: data?.project?.tasksCount,
    loading
  };
};

export default useProjectKPISummary;
